import { BasicCampaignResourceModel } from '@/modules/base-campaign/models/base-campaign-resource.model'
import { BasicUserResourceModel } from '@/modules/user/models/user-resource.model'
import { ContentResourceModel } from '@/modules/content/models/content-resource.model'
import { Data } from '@/modules/shared/models/data'


export enum ContentItemStatus {
  WAITING_PAYMENT = 'waiting-payment',
  PENDING = 'pending',
  QUEUE = 'queue',
  EDITING = 'editing',
  COMPLETED = 'completed',
  REVIEW = 'review',
  REJECTED = 'rejected',
  CANCELLED = 'cancelled',
}

export enum ContentItemType {
  ARTICLE = 'article',
  REPORTAGE = 'reportage',
  PRODUCT = 'product',
  LANDING = 'landing',
}


export enum ContentTones {
  FORMAL = 'formal',
  INFORMAL = 'informal',
}

export enum ContentWordCount {
  WORD_COUNT_1000 = 1000,
  WORD_COUNT_1200 = 1200,
  WORD_COUNT_1500 = 1500,
  WORD_COUNT_2000 = 2000,
  WORD_COUNT_2500 = 2500,
  WORD_COUNT_3000 = 3000,
  WORD_COUNT_3500 = 3500,
  WORD_COUNT_4000 = 4000,
  WORD_COUNT_4500 = 4500,
  WORD_COUNT_5000 = 5000,
}

export interface BasicContentItemResourceModel {
  id: number
  status: ContentItemStatus
}

export interface ContentItemResourceModel {
  id: number,
  status: ContentItemStatus,
  title: string | null,
  main_keyword: string | null,
  keywords: string[] | null,
  word_count: number,
  content_type: ContentItemType,
  tone: ContentTones,
  description: string | null,
  rejection_reason: string | null,
  step: number | null,
  price: number | null,
  system_discount: number | null,
  manual_discount: number | null,
  coupon_discount: number | null,
  total_discount: number | null,
  payable: number | null,
  delivery_order: string | null,
  register_at: string | null,
  deliver_at: string | null,
  completed_at: string | null,
  seen_at: string | null,
  created_at: string | null,
  content: ContentResourceModel | null,
  writer: BasicUserResourceModel | null,
  editor: BasicUserResourceModel | null,
  campaign: BasicCampaignResourceModel,
  reference_url: string
}

interface ContentItemResourceModelWriter extends ContentItemResourceModel {
  production_guide?: string | null,
  sent_to_queue_at?: string | null,
  review_reason?: string | null,
  writer_share?: number | null,
}

interface ContentItemResourceModelInAdmin extends ContentItemResourceModelWriter {
  user?: BasicUserResourceModel,
  profit?: number,
  admin_note?: string | null,
}

export interface ContentItemResourceWithModel {
  statuses: { [key in ContentItemStatus]: string },
  content_types: { [key in ContentItemType]: string },
  tones: { [key in ContentTones]: string },
  word_counts: { [key in ContentWordCount]: string },
  model_type?: string
}

export interface ContentItemUpdatableAttributesResourceModel {
  id: number
  status: ContentItemStatus
  writer_share: number | null,
  title: string | null
  main_keyword: string | null
  word_count: number
  keywords: Array<string> | null
  content_type: ContentItemType
  tone: ContentTones
  description: string | null
  production_guide: string | null
  review_reason: string | null
  admin_note: string | null
  deliver_at: string | null
  completed_at: string | null
  sent_to_queue_at: string | null,
  editor_id: number | null
}

export interface ContentItemGetDataForCompleteResourceModel {
  id: number
  status: ContentItemStatus
  writer: BasicUserResourceModel | null
  word_rate: number | null
  payable: number | null
  update_writer_share: boolean
  writer_share: number
}

export interface ContentItemContentResourceModel {
  id: number
  status: string
  step: number
  deliver_at: string
  completed_at: string
  assignable: boolean
  content: ContentResourceModel
}

export interface ContentItemContentResourceWithModel {
  statuses: { [key in ContentItemStatus]: string },
}

export type ContentItemUpdatableAttributesResourceTypeInAdmin =
  Data<ContentItemUpdatableAttributesResourceModel>
  & ContentItemResourceWithModel

export type ContentItemResourceType = Data<ContentItemResourceModel> & ContentItemResourceWithModel

export type ContentItemContentResourceType = Data<ContentItemContentResourceModel> & ContentItemContentResourceWithModel
